var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcnBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus-icn-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile---dtc-confirm-car",
    transform: "translate(-100.000000, -1498.000000)",
    fill: "#0B7BFB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2733\\uFE0F-molecules/summary-page/driver-details",
    transform: "translate(16.000000, 1360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "summary"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title-row",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/summary/title-row"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDB1-Button",
    transform: "translate(44.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grey-Pill-Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B-atoms/icons/16/plus/blue",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-icn-blue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.006006,5.92375 L0.993993994,5.92375 C0.44502627,5.92375 0,6.40560354 0,7 C0,7.59439646 0.44502627,8.07625 0.993993994,8.07625 L13.006006,8.07625 C13.5549737,8.07625 14,7.59439646 14,7 C14,6.40560354 13.5549737,5.92375 13.006006,5.92375 Z",
    id: "Rectangle-20",
    transform: "translate(7.000000, 7.000000) rotate(-90.000000) translate(-7.000000, -7.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.006006,5.92375 L0.993993994,5.92375 C0.44502627,5.92375 0,6.40560354 0,7 C0,7.59439646 0.44502627,8.07625 0.993993994,8.07625 L13.006006,8.07625 C13.5549737,8.07625 14,7.59439646 14,7 C14,6.40560354 13.5549737,5.92375 13.006006,5.92375 Z",
    id: "Rectangle-20",
    transform: "translate(7.000000, 7.000000) scale(-1, 1) translate(-7.000000, -7.000000) "
  })))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcnBlue);
export default __webpack_public_path__ + "static/media/plus-icn-blue.0dfe5f31c87531e25f5a1a7de9dcfd55.svg";
export { ForwardRef as ReactComponent };